:host {
  /**
  * @prop --fds-icon-icon-color: The current color of the icon
  */
  --fds-icon-icon-color: var(--fds-icon-button-icon-color, 'currentColor');

  display: flex;
}

svg {
  color: var(--fds-icon-icon-color);
}
